import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class ConfigFieldFormValueObject extends ValueObject {
  /**
   * @param {Object}   params
   * @param {String}   params.context
   * @param {Object[]}   params.datalist
   * @param {String}   params.datalist[].text
   * @param {String}   params.datalist[].value
   * @param {String}   params.display
   * @param {Boolean}   params.disabled
   * @param {String}   params.help
   * @param {String}   params.hint
   * @param {String}   params.id
   * @param {String}   params.label
   * @param {Boolean}   params.required
   * @param {String}   params.tabIndex
   * @param {String}   params.type
   */

  /**
   * Validate ConfigFieldFormValueObject id
   * @static
   */
  static validate({id, errorFactory} = {}) {
    if (!id) {
      throw errorFactory(`[ConfigFieldFormValueObject] Bad request parameters`)
    }
  }
}
